<template>
  <div id="loggedOut">
    <div class="tagline-background px-xs-6">
      <div
        class="main-header--home__layout transition transition--header transition-end d-none d-sm-block"
      >
        <nuxt-img
          preload
          class="device-laptop transition--header__fade-in"
          src="/img/website/laptop-landing page.webp"
          alt="using a laptop to code on Elementari"
        />
        <div class="shadow-container transition--header__fade-in">
          <nuxt-img
            preload
            class="device-laptop-shadow transition--header__fade-in"
            src="/img/website/homepage-laptop-shadow.png"
            alt="using a laptop to code on Elementari"
          />
        </div>
        <nuxt-img
          preload
          class="device-tablet transition--header__fade-in"
          src="/img/website/tablet-landingpage.webp"
          alt="using a tablet to write on Elementari"
        />
        <div class="shadow-container transition--header__fade-in">
          <nuxt-img
            preload
            class="device-tablet-shadow transition--header__fade-in"
            src="/img/website/homepage-laptop-shadow.png"
            alt="using a tablet to write on Elementari"
          />
        </div>
        <svg
          height="330px"
          width="330px"
          viewBox="0 0 330 330"
          class="circle-1 circle transition--header__fade-in opacity-2"
        >
          <circle cx="165" cy="165" r="165" fill="#F8F9FF" />
        </svg>
        <svg
          height="248px"
          width="248px"
          viewBox="0 0 248 248"
          class="circle-2 circle transition--header__fade-in opacity-5"
        >
          <circle cx="124" cy="124" r="124" fill="#F1D3FA" />
        </svg>
        <svg
          height="34px"
          width="34px"
          viewBox="0 0 34 34"
          class="circle-3 circle transition--header__fade-in opacity-9"
        >
          <circle cx="17" cy="17" r="17" fill="#B8EAFD" />
        </svg>
        <svg
          height="30px"
          width="30px"
          viewBox="0 0 30 30"
          class="circle-4 circle transition--header__fade-in opacity-9"
        >
          <circle cx="15" cy="15" r="15" fill="#F1D3FA" />
        </svg>
        <svg
          height="80px"
          width="80px"
          viewBox="0 0 80 80"
          class="circle-5 circle transition--header__fade-in opacity-8"
        >
          <circle cx="40" cy="40" r="40" fill="#B8E7FF" />
        </svg>
        <svg
          height="888px"
          width="888px"
          viewBox="0 0 888 888"
          class="circle-6 circle transition--header__fade-in opacity-2"
        >
          <circle cx="444" cy="444" r="444" fill="#F8F9FF" />
        </svg>
        <svg
          height="136px"
          width="136px"
          viewBox="0 0 136 136"
          class="circle-7 circle transition--header__fade-in opacity-5"
        >
          <circle cx="68" cy="68" r="68" fill="#D7FBCA" />
        </svg>
        <svg
          height="116px"
          width="116px"
          viewBox="0 0 116 116"
          class="circle-8 circle transition--header__fade-in opacity-5"
        >
          <circle cx="58" cy="58" r="58" fill="#EBD0FA" />
        </svg>
        <svg
          height="48px"
          width="48px"
          viewBox="0 0 48 48"
          class="circle-9 circle transition--header__fade-in opacity-8"
        >
          <circle cx="24" cy="24" r="24" fill="#B7E5FF" />
        </svg>
        <svg
          height="34px"
          width="34px"
          viewBox="0 0 34 34"
          class="circle-10 circle transition--header__fade-in opacity-9"
        >
          <circle cx="17" cy="17" r="17" fill="#B7E5FF" />
        </svg>
      </div>
      <v-container class="tagline-wrapper-banner text-center">
        <h1
          class="text-center mx-auto alt-1 mb-10 font-weight-black pt-16 pt-sm-0 mt-6 mt-sm-0"
        >
          {{ $t('home_page.tagline') }}
        </h1>

        <p class="mb-10 text-sm-h6" style="max-width: 800px; margin: 0 auto">
          {{ $t('home_page.subtitle') }}
        </p>

        <div class="mb-10">
          <v-btn color="accent" x-large @click="toggleSignupDialog">
            {{ $t('home_page.create_btn') }}
          </v-btn>
          <v-btn x-large @click="toggleLoginDialog">
            {{ $t('navbar.login.title') }}
          </v-btn>
        </div>

        <v-flex
          class="desktop-awards-row pb-3"
          style="display: flex; justify-content: center"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://studentprivacypledge.org/signatories/"
            class="mr-4"
          >
            <img
              src="/img/website/Student Privacy Pledge Sig_logo.webp"
              style="max-width: 100px"
              height="50px"
              width="100px"
              alt="Student Privacy Pledge Signatory"
            />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.ala.org/aasl/"
            class="mr-4"
          >
            <img
              src="/img/website/AASL.webp"
              style="text-align: center; max-width: 80px"
              height="80px"
              width="70px"
              alt="American Association of School Librarians Best Websites for Teaching and Learning 2019"
            />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.commonsense.org/education/website/elementari"
          >
            <img
              src="/img/website/commonsense.webp"
              style="text-align: center; max-width: 80px"
              height="80px"
              width="80px"
              alt="Common Sense Website List"
            />
          </a>
        </v-flex>
      </v-container>
    </div>
    <section class="section-padding mx-auto" style="max-width: 1100px">
      <div class="container">
        <h2
          class="alt-h2 text-center gradient-text-blue-purple font-weight-black mb-12"
        >
          {{ $t('home_page.lessons.header') }}
        </h2>
        <h4 class="mb-16 text-center" style="margin: auto; max-width: 700px">
          {{ $t('home_page.lessons.subtitle') }}
        </h4>
        <v-layout class="classGrid mx-auto" row wrap style="min-height: 300px">
          <v-row>
            <v-col
              v-for="(obj, index) in tryOutLessons"
              :key="obj.slug"
              cols="12"
              sm="6"
              md="4"
              class="pa-1 pa-md-3 d-flex justify-center"
              :class="{
                'd-sm-none d-md-block': index === tryOutLessons.length - 1
              }"
            >
              <published-lesson-card
                :slug="obj.slug"
                :thumbnail="obj.thumbnail"
                :name="obj.name"
                :description="obj.description"
                :grade="obj.grade"
                :subjects="obj.subjects"
                :time-required="obj.timeRequired"
                :speakers="obj.speakers"
                :microphone="obj.microphone"
                style="max-width:450px;"
              />
            </v-col>
          </v-row>
        </v-layout>
      </div>
      <div class="text-center mt-10">
        <v-btn x-large color="accent" :to="localePath('/lessons/')">
          {{ $t('home_page.lessons.button') }}
        </v-btn>
      </div>
    </section>
    <div
      min-height="200"
      transition="fade-transition"
      style="background-color: rgb(254, 255, 254)"
    >
      <section class="section-padding mx-auto" style="max-width: 1100px">
        <div class="container">
          <h2
            class="alt-h2 text-center gradient-text-blue-purple font-weight-black mb-12"
          >
            {{ $t('home_page.why.title') }}
          </h2>
          <h4 class="mb-16 text-center" style="margin: auto; max-width: 600px">
            {{ $t('home_page.why.subtitle') }}
          </h4>

          <v-container>
            <v-row align="center" class="mb-sm-5 flex-column-reverse flex-sm-row">
              <!-- Text Content -->
              <v-col cols="12" sm="6" class="px-2 py-3">
                <h3
                  class="text-h5 text-md-h4 font-weight-medium text-center text-sm-left"
                >
                  {{ $t('home_page.why.literacy_title') }}
                </h3>
                <p>
                  {{ $t('home_page.why.literacy_content') }}
                </p>
                <!-- <nuxt-link
        target="_blank"
        class="font-weight-medium"
        :to="localePath('/why-creative-coding/')"
      >
        {{ $t('home_page.why.literacy_link') }}
                               <v-icon size="18" color="primary" class="link-icon">{{
                        icons.mdiArrowRight
                      }}</v-icon>
      </nuxt-link> -->
              </v-col>

              <!-- Image Column -->
              <v-col cols="12" sm="6" class="px-2 py-3 d-flex justify-center">
                <nuxt-img
                  src="/img/website/resources/2nd-grade-students.jpg"
                  alt="Classroom using Elementari on tablets"
                  format="webp"
                  sizes="xs:320px sm:50vw md:50vw lg:500px"
                  class="mx-auto"
                  style="border-radius: 6px; object-fit: cover; max-width: 100%; width: 100%;"
                />
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-row align="center" class="mb-sm-5 flex-sm-row-reverse flex-column-reverse flex-sm-row">
              <!-- Text Content -->
              <v-col cols="12" sm="6" class="px-2 py-3">
                <h3
                  class="text-h5 text-md-h4 font-weight-medium text-center text-sm-left"
                >
                  {{ $t('home_page.why.future_ready_title') }}
                </h3>
                <p>
                  {{ $t('home_page.why.future_ready_content') }}
                </p>
              </v-col>

              <!-- Image Column -->
              <v-col cols="12" sm="6" class="px-2 py-3 d-flex justify-center">
                <nuxt-img
                  src="/img/website/resources/teacher1.jpg"
                  alt="Teacher helping students using Elementari"
                  format="webp"
                  
                  sizes="xs:320px sm:50vw md:50vw lg:500px"
                  class=" mx-auto"
                  style="border-radius: 6px; object-fit: cover; max-width: 100%; width: 100%;"
                />
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-row align="center" class="mb-sm-5 flex-column-reverse flex-sm-row" >
              <!-- Text Content -->
              <v-col cols="12" sm="6" class="px-2 py-3">
                <h3
                  class="text-h5 text-md-h4 font-weight-medium text-center text-sm-left"
                >
                  {{ $t('home_page.why.engage_title') }}
                </h3>
                <p>
                  {{ $t('home_page.why.engage_content') }}
                </p>
                <nuxt-link
                  target="_blank"
                  class="font-weight-medium internal-link"
                  :to="localePath('/why-creative-coding')"
                >
                  {{ $t('home_page.why.engage_link') }}
                  <v-icon size="18" color="primary" class="link-icon">{{
                        icons.mdiArrowRight
                      }}</v-icon>
                </nuxt-link>
              </v-col>

              <!-- Image Column -->
              <v-col cols="12" sm="6" class="px-2 py-3 d-flex justify-center">
                <nuxt-img
                  src="/img/website/resources/12-grade-presentation.jpg"
                  alt="12th grade student presentation using Elementari"
                  format="webp"
                  
                  sizes="xs:320px sm:50vw md:50vw lg:500px"
                  class="mx-auto"
                  style="border-radius: 6px; object-fit: cover; min-height: 300px; max-width: 100%; width: 100%;"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </section>
    </div>

    <section
      class="section-padding mx-auto text-center"
      style="max-width: 1100px"
    >
      <div class="container">
        <h2
          class="alt-h2 text-center gradient-text-blue-purple font-weight-black mb-12"
        >
          {{ $t('home_page.how.title') }}
        </h2>
        <h4 class="mb-16 text-center" style="margin: auto; max-width: 800px">
          {{ $t('home_page.how.subtitle') }}
        </h4>

        <v-row>
          <v-col cols="12" sm="12" lg="4">
            <nuxt-img
              class="mb-8"
              src="/img/owl-6.png"
              format="webp"
              placeholder
              sizes="xs:100vw sm:50vw md:33vw"
              style="width: 100%; height: 200px; object-fit: contain"
            />

            <h4 class="font-weight-medium text-center">
              {{ $t('home_page.how.lesson_title') }}
            </h4>
            <p style="min-height: 81px">
              {{ $t('home_page.how.lesson_content') }}
            </p>
            <nuxt-link
              target="_blank"
              class="font-weight-medium internal-link"
              :to="localePath('/lessons/')"
            >
              {{ $t('home_page.how.lesson_link') }}
              <v-icon size="18" color="primary" class="link-icon">{{
                        icons.mdiArrowRight
                      }}</v-icon>
            </nuxt-link>
          </v-col>

          <v-col cols="12" sm="12" lg="4">
            <nuxt-img
              class="mb-8"
              src="/img/mouse-3.png"
              format="webp"
              
              sizes="xs:100vw sm:50vw md:33vw"
              style="width: 100%; height: 200px; object-fit: contain"
            />

            <h4 class="font-weight-medium text-center">
              {{ $t('home_page.how.code_title') }}
            </h4>
            <p style="min-height: 81px">
              {{ $t('home_page.how.code_content') }}
            </p>
            <nuxt-link
              target="_blank"
              class="font-weight-medium internal-link"
              :to="localePath('/what-is-visual-coding/')"
            >
              {{ $t('home_page.how.code_link') }}
              <v-icon size="18" color="primary" class="link-icon">{{
                        icons.mdiArrowRight
                      }}</v-icon>
            </nuxt-link>
          </v-col>

          <v-col cols="12" sm="12" lg="4">
            <nuxt-img
              class="mb-8"
              src="/img/mailman.png"
              format="webp"
              
              sizes="xs:100vw sm:50vw md:33vw"
              style="width: 100%; height: 200px; object-fit: contain"
            />

            <h4 class="font-weight-medium text-center">
              {{ $t('home_page.how.share_title') }}
            </h4>
            <p style="min-height: 81px">
              {{ $t('home_page.how.share_content') }}
            </p>
            <nuxt-link
              target="_blank"
              class="font-weight-medium internal-link"
              :to="localePath('/projects/')"
            >
              {{ $t('home_page.how.share_link') }}
              <v-icon size="18" color="primary" class="link-icon">{{
                        icons.mdiArrowRight
                      }}</v-icon>
            </nuxt-link>
          </v-col>
        </v-row>
                    <!-- Center Button on Small Screens -->
                    <div class="d-flex justify-center mt-10">
              <v-btn color="accent" x-large :to="localePath('/getting-started/')">
                {{ $t('plans.startNow') }}
              </v-btn>
            </div>
      </div>
    </section>

    <div
      min-height="200"
      transition="fade-transition"
      style="background-color: rgb(254, 255, 254)"
    >
      <section class="section-padding mx-auto" style="max-width: 1100px">
        <div class="container">
          <h2
            class="alt-h2 text-center gradient-text-blue-purple font-weight-black mb-12"
          >
            {{ $t('home_page.toolkit.title') }}
          </h2>
          <h4 class="mb-16 text-center" style="margin: auto; max-width: 800px">
            {{ $t('home_page.toolkit.subtitle') }}
          </h4>
        </div>

        <v-row align="center">
          <!-- Image Column -->
          <v-col cols="12" sm="12" md="6" lg="6" class="d-flex justify-center">
            <nuxt-img
              src="/img/website/educator/diverse-learners.png"
              alt="Mosaic of kids working on Elementari"
              format="webp"
              
              sizes="xs:320px sm:80vw md:80vw lg:500px"
              style="border-radius: 6px; object-fit: cover"
            />
          </v-col>

          <!-- Content Column -->
          <v-col cols="12" sm="12" md="6" lg="6">
            <ul class="checkmark-list">
              <li
                v-for="(content, index) in $t('home_page.toolkit.content')"
                :key="index"
                class="mb-12 text-h6 font-weight-medium"
              >
                {{ content.text }}
              </li>
            </ul>

            <!-- Center Button on Small Screens -->
            <div class="d-flex justify-center">
              <v-btn color="accent" x-large :to="localePath('/features/')">
                {{ $t('home_page.toolkit.cta') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </section>
    </div>

    <section
      class="pt-0"
      style="
        background-image: url('/img/grid.png');
        background-repeat: repeat;
        z-index: 1;
      "
    >
      <v-container class="mx-auto d-block d-sm-flex" style="max-width: 1100px">
        <v-row>
          <v-col
            cols="12"
            md="8"
            class="text-center text-sm-left py-16"
            style="color: white; align-self: center; justify-self: center"
          >
            <h2
              class="alt-h2 gradient-text-orange-yellow font-weight-black mb-12"
            >
              {{ $t('home_page.school.title') }}
            </h2>
            <h4 class="mb-12">
              {{ $t('home_page.school.subtitle') }}
            </h4>
            <p>{{ $t('home_page.school.content') }}</p>
            <v-btn
              x-large
              color="accent"
              class="mt-10"
              :to="localePath('/schools-districts/')"
            >
              {{ $t('home_page.school.cta_schools') }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="4" class="d-none d-sm-block">
            <nuxt-img
              src="/img/website/home-blocks-display.png"
              alt="Image of different Elementari coding blocks on a dark grey grid."
              format="webp"
              
              style="
                width: 100%;
                height: auto;
                object-fit: cover;
                position: absolute;
              "
            />
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section
      class="section-padding"
      style="z-index: 2; background-color: white"
    >
      <v-container style="max-width: 1100px">
        <h2
          class="alt-h2 text-center gradient-text-blue-purple font-weight-black mb-12"
        >
          {{ $t('home_page.educators.title') }}
        </h2>
        <h4 class="mb-16 text-center" style="margin: auto; max-width: 800px">
          {{ $t('home_page.educators.subtitle') }}
        </h4>

        <v-carousel
          height="400"
          interval="10000"
          style="border-radius: 18px"
          :cycle="true"
          :show-arrows="false"
        >
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet height="100%" :style="slide.color">
              <v-container fill-height>
                <v-flex align-center justify-center class="px-5">
                  <p class="mb-4 font-weight-normal" style="font-style: italic">
                    "{{ $t('educators_page.quotes.' + slide.quote) }}"
                  </p>
                  <v-layout>
                    <v-avatar :size="56" color="grey lighten-5 mr-4">
                      <v-img
                        :src="slide.avatar"
                        :lazy-src="slide.avatar"
                        :alt="slide.person"
                      />
                    </v-avatar>
                    <div>
                      <p
                        class="mb-0"
                        style="font-size: 14px !important; font-weight: 300"
                      >
                        {{ $t('educators_page.quotes.' + slide.position) }}
                      </p>
                      <p
                        class="mb-0"
                        style="font-size: 12px !important; font-weight: 300"
                      >
                        {{
                          $t(
                            'educators_page.quotes.' + slide.position + 'School'
                          )
                        }}
                      </p>
                    </div>
                  </v-layout>
                  <div v-if="slide.caseStudy" class="mt-4">
                    <v-btn
                      class="default"
                      :href="slide.caseStudy"
                      target="_blank"
                    >
                      Read the Case Study
                    </v-btn>
                  </div>
                </v-flex>
              </v-container>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-container>
    </section>
    <call-to-action-teacher class="px-16" />
    <main-footer />
  </div>
</template>

<script>
import {
  mdiArrowRight,
} from '@mdi/js'
  // import PublishedLessonCard from '~/components/home/PublishedLessonCard.vue'
  // import FeatureDemo from '~/components/home/FeatureDemo.vue'
  // import MainFooter from '~/components/MainFooter.vue'
  export default {
    components: {
      'published-lesson-card': () =>
        import('~/components/home/PublishedLessonCard.vue'),
      // 'feature-demo': () => import('~/components/home/FeatureDemo.vue'),
      'call-to-action-teacher': () =>
        import('~/components/utils/CallToActionTeacher.vue'),
      'main-footer': () => import('~/components/MainFooter.vue')
    },
    data() {
      return {
        icons: {
          mdiArrowRight
        },
        // lessonVideo1Visible: false,
        // lessonVideo2Visible: false,
        isRemoteTeachingActive: false,
        mobileYouTubeDemo: false,
        tryOutLessons: [
          {
            slug: 'growing-tree-code-speech',
            name: 'Growing Tree: Code Speech 🌱',
            thumbnail:
              '/img/website/kids-coding-lesson-an-interactive-environment-story.jpg',
            description:
              "Code an interactive story where a magical tree grows when specific words are spoken. Students will design their story with images and backgrounds, write a 'Tree Keeper Promise' to care for trees, and code speech recognition to make their tree respond to their voice. This lesson combines coding with creative storytelling, making it ideal for an Earth Day and Arbor Day activity.",
            timeRequired: 50,
            subjects: ['l', 'm'],
            grade: 'K-2',
            microphone: true,
            speakers: false
          },
          {
            slug: 'spy-coding-invisible-ink',
            name: 'Spy Story: Invisible Ink 🔥',
            thumbnail:
              '/img/website/kids-coding-a-story-lesson-for-history.jpg',
            description:
              "Embark on a captivating adventure into the secret world of spies and invisible ink, inspired by Josephine Baker's remarkable espionage during World War II. In this interactive lesson, students will write a narrative hook and code a hidden message to reveal by dragging an object over it, blending history with the magic of coding.",
            timeRequired: 50,
            subjects: ['l', 'm'],
            grade: '3-5',
            microphone: false,
            speakers: true
          },
          {
            slug: 'history-truths-myths-game',
            name: 'Historical Truths Game 🎓',
            thumbnail: '/img/website/kids-coding-a-game-lesson-for-history.jpg',
            description:
              'Design and code an engaging true/false interactive game about a historical figure - combining interactive slides with true/false choices, a dynamic scoring system, and conditional logic. Students will research historical facts, then apply coding concepts to track scores and direct game outcomes based on player responses. This lesson merges historical inquiry with computational thinking.',
            timeRequired: 100,
            subjects: ['m', 'h'],
            grade: '6-12',
            microphone: false,
            speakers: false
          }
        ],
        slides: [
          {
            color:
              'background: linear-gradient(45deg, rgba(239,83,80,1) 0%, rgba(245,152,150,1) 100%);',
            quote: 'q1',
            avatar: '/img/website/ambassadors/ameerah_small.jpg',
            person: 'Ameerah',
            image: '/img/website/educator/testimonials/community5.JPG',
            position: 'q1Teacher'
          },
          {
            color:
              'background: linear-gradient(45deg, rgba(73,151,208,1) 0%, rgba(145,192,226,1) 100%);',
            quote: 'q2',
            avatar: '/img/website/ambassadors/rachel_small.png',
            person: 'Rachel',
            image: '/img/website/educator/testimonials/community2.jpg',
            position: 'q2Teacher',
            caseStudy:
              'https://elementari.com/files/CaseStudies/EFL-Summer-Literature-Course.pdf'
          },
          {
            color:
              'background: linear-gradient(45deg, rgba(255,136,62,1) 0%, rgba(255,183,139,1) 100%);',
            quote: 'q3',
            avatar: '/img/website/ambassadors/owl_small.jpg',
            person: 'Owl',
            image: '/img/website/educator/testimonials/community3.jpg',
            position: 'q3Teacher'
          },
          {
            color:
              'background: linear-gradient(45deg, rgba(129,182,105,1) 0%, rgba(179,211,165,1) 100%);',
            quote: 'q4',
            avatar: '/img/website/ambassadors/laura_small.png',
            person: 'Owl',
            image: '/img/website/educator/testimonials/community1.jpg',
            position: 'q4Teacher',
            caseStudy:
              'https://elementari.com/files/CaseStudies/EFL-Creative-Writing-Unit.pdf'
          },
          {
            color:
              'background: linear-gradient(45deg, rgba(158,105,182,1) 0%, rgba(196,165,211,1) 100%);',
            quote: 'q5',
            avatar: '/img/website/ambassadors/boysgirls_small.png',
            person: 'Boys and Girls Club',
            image:
              'https://elementari.com/img/website/educator/testimonials/community4.jpeg',
            position: 'q5Teacher',
            caseStudy:
              'https://elementari.com/files/CaseStudies/Boys-and-Girls-Club-Petersburg.pdf'
          }
        ]
      }
    },
    computed: {
      gettingStartedSteps: function () {
        return [
          {
            title: this.$t('home_page.get_started.access_title'),
            desc: this.$t('home_page.get_started.access_subtitle'),
            src: '/img/website/laptop.png',
            alt: 'laptop',
            gradient:
              'linear-gradient(45deg, rgba(107,233,81,1) 0%, rgba(81,107,233,1) 100%);'
          },
          {
            title: this.$t('home_page.get_started.classroom_title'),
            desc: this.$t('home_page.get_started.classroom_subtitle'),
            src: 'https://d35gz3cm1ahlmo.cloudfront.net/cache/b1/7b/b17b732651b5afd35c778177a3ed7c3e.png',
            alt: 'invitation card',
            gradient:
              'linear-gradient(45deg, rgba(63,84,230,1) 0%, rgba(230,63,84,1) 100%);'
          },
          {
            title: this.$t('home_page.get_started.lesson_title'),
            desc: this.$t('home_page.get_started.lesson_subtitle'),
            src: 'https://d35gz3cm1ahlmo.cloudfront.net/cache/61/84/61844f33c66821be625ebc56928c2819.png',
            alt: 'compass',
            gradient:
              'linear-gradient(45deg, rgba(175,209,197,1) 0%, rgba(197,175,209,1) 100%);'
          }
        ]
      }
    },
    methods: {
      // onIntersect(entries) {
      //   const [entry] = entries
      //   if (entry.isIntersecting) {
      //     this.lessonVideo1Visible = true
      //     // Check if both videos are ready to play
      //     this.checkAndPlayVideos()
      //     // Optionally delay the second fade-in
      //     setTimeout(() => {
      //       this.lessonVideo2Visible = true
      //     }, 300) // Adjust the delay as necessary
      //   } else {
      //     // Optional: Reset visibility if you want them to fade in again when re-scrolling into view
      //     this.lessonVideo1Visible = false
      //     this.lessonVideo2Visible = false
      //     this.pauseVideos()
      //   }
      // },
      // checkAndPlayVideos() {
      //   const video1 = this.$refs.video1
      //   const video2 = this.$refs.video2

      //   // Check if both videos can play through
      //   const canPlay = () => {
      //     if (video1.readyState >= 4 && video2.readyState >= 4) {
      //       video1.play()
      //       video2.play()
      //     } else {
      //       setTimeout(canPlay, 100) // Check every 100ms
      //     }
      //   }
      //   canPlay()
      // },

      // pauseVideos() {
      //   const video1 = this.$refs.video1
      //   const video2 = this.$refs.video2
      //   if (video1 && video2) {
      //     video1.pause()
      //     video2.pause()
      //   }
      // },
      // handleVideoEnd() {
      //   this.video1Ended = true
      //   this.video2Ended = true
      //   if (this.video1Ended && this.video2Ended) {
      //     this.$refs.video1.currentTime = 0
      //     this.$refs.video2.currentTime = 0
      //     this.video1Ended = false
      //     this.video2Ended = false
      //     this.$refs.video1.play()
      //     this.$refs.video2.play()
      //   }
      // },
      toggleSignupDialog() {
        this.$store.dispatch('setSignupDialog', !this.$store.state.signupDialog)
      },
      toggleLoginDialog() {
        this.$store.dispatch('setLoginDialog', !this.$store.state.loginDialog)
      }
    }
  }
</script>

<style>
  #loggedOut p {
    font-size: 1.125rem;
  }
  #learning video {
    max-height: 375px;
    width: 100%;
  }
  .tagline-background {
    position: relative;
    background-color: #00c4c5;
    background: linear-gradient(to left top, #174694 0, #00afb0 100%);
    overflow: hidden;
  }

  #footer {
    background-color: #174694;
    color: #fff;
  }

  .curriculum-container {
    color: white;
    background: linear-gradient(to left top, #123876 0, #0c7aa2 100%);
  }
  .stat-fact {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    margin-top: 8px;
  }
  .elementari-header-desktop {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 1;
  }
  @media (max-width: 1176px) {
    .elementari-header-desktop {
      z-index: auto;
      opacity: 0.4;
    }
  }

  .coupon {
    position: absolute;
    top: 0px;
  }

  .coupon img {
    max-width: 17em;
  }

  .couponMobile {
    display: none;
  }
  .elementari-header-desktop img {
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 20px 0;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    vertical-align: bottom;
  }
  @media (max-width: 800px) {
    .elementari-header-desktop img {
      width: 500px;
      height: auto;
    }

    .coupon {
      left: 69%;
      z-index: 1;
    }

    .coupon img {
      max-width: 13em;
    }
  }
  @media (max-width: 550px) {
    .elementari-header-desktop img {
      width: 325px;
    }
    .coupon {
      display: none;
    }

    .couponMobile {
      display: block;
      background-color: #f7931e;
      color: white;
      font-weight: 500;
    }
  }
  .tagline-background .container {
    height: 100%;
    position: relative;
  }

  .tagline-wrapper-banner {
    z-index: 3;
    color: white;
  }

  .desktop-awards-row {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    /* flex-direction: column; */
  }

  @keyframes MoveUpDownDevices {
    0%,
    100% {
      transform: translateY(-6%);
    }
    50% {
      transform: translateY(2%);
    }
  }
  @keyframes MoveUpDownDevicesTiltLeft {
    0%,
    100% {
      transform: translateY(-6%);
    }
    50% {
      transform: translateY(2%);
    }
  }
  @keyframes MoveUpDownDevicesTiltRight {
    0%,
    100% {
      transform: translateY(-6%);
    }
    50% {
      transform: translateY(2%);
    }
  }
  @keyframes MoveUpDown {
    0%,
    100% {
      transform: translateY(20px);
    }
    50% {
      transform: translateY(0%);
    }
  }
  @keyframes FadeInOut {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
  }
  .main-header--home__layout {
    height: 170px;
    left: 50%;
    position: relative;
    z-index: 0;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout {
      height: 370px;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout {
      /* height: 500px; */
      height: 429px;
    }
    .stat-fact {
      max-width: 500px;
    }
  }
  .main-header--home__layout img,
  .main-header--home__layout svg {
    pointer-events: none;
    position: absolute;
    transition: opacity 0.5s linear, top 0.5s cubic-bezier(0, 0, 0, 1);
  }

  .main-header--home__layout .circle {
    transition: opacity 2s linear;
  }
  .main-header--home__layout .shadow-container {
    transition: opacity 0.5s linear;
    transition-delay: 1s;
  }
  .main-header--home__layout .shadow-container--1 {
    transition-delay: 0.5s;
  }
  .main-header--home__layout .device-laptop {
    animation: MoveUpDownDevicesTiltLeft 8s ease-in-out infinite;
    left: -160px;
    top: 17%;
    transition-delay: 1s;
    width: 170px;
    z-index: 10;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .device-laptop {
      left: -320px;
      top: 80px;
      width: auto;
      max-width: 350px;
      z-index: 10;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .device-laptop {
      animation: MoveUpDownDevices 8s ease-in-out infinite;
    }
  }
  .main-header--home__layout .device-tablet {
    animation: MoveUpDownDevicesTiltRight 8s ease-in-out infinite;
    animation-delay: -3s;
    /* left: -90px; */
    left: -50px;
    max-width: 600px;
    /* top: 40%; */
    top: 17%;
    transition-delay: 0.5s;
    /* width: 260px; */
    width: 220px;
    z-index: 11;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .device-tablet {
      left: -120px;
      width: 450px;
      top: 18%;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .device-tablet {
      animation: MoveUpDownDevices 8s ease-in-out infinite;
      animation-delay: -3s;
      /* left: -125px; */
    }
  }
  .main-header--home__layout .device-laptop-shadow {
    animation: FadeInOut 8s ease-in-out infinite;
    display: none;
    left: -71%;
    top: 72%;
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .device-laptop-shadow {
      display: block;
      left: -660px;
      /* top: 430px; */
      top: 354px;
      z-index: 1;
    }
  }
  .main-header--home__layout .device-tablet-shadow {
    animation: FadeInOut 8s ease-in-out infinite;
    animation-delay: -3s;
    left: -35%;
    top: 95%;
    z-index: 1;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .device-tablet-shadow {
      left: -230px;
      top: 90%;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .device-tablet-shadow {
      /* left: -210px;
    top: 460px; */
      left: -210px;
      top: 364px;
    }
  }
  .main-header--home__layout .circle-1 {
    animation: MoveUpDown 8s ease-in-out infinite;
    animation-delay: -1s;
    left: -85%;
    top: 27%;
    width: 200px;
    z-index: 2;
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-1 {
      left: -710px;
      top: 100px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-2 {
    animation: MoveUpDown 6s ease-in-out infinite;
    animation-delay: -5.5s;
    left: -45%;
    top: 47%;
    width: 95px;
    z-index: 3;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-2 {
      left: -330px;
      top: 47%;
      width: 170px;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-2 {
      left: -550px;
      top: 320px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-3 {
    animation: MoveUpDown 5s ease-in-out infinite;
    animation-delay: -8s;
    left: -40%;
    top: 20%;
    width: 25px;
    z-index: 9;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-3 {
      left: -260px;
      top: 28%;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-3 {
      left: -360px;
      top: 130px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-4 {
    animation: MoveUpDown 4s ease-in-out infinite;
    animation-delay: -2s;
    display: none;
    left: -34%;
    top: 79%;
    z-index: 3;
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-4 {
      display: block;
      left: -190px;
      top: 180px;
    }
  }
  .main-header--home__layout .circle-5 {
    animation: MoveUpDown 4s ease-in-out infinite;
    animation-delay: -3s;
    display: none;
    left: -45%;
    top: 27%;
    z-index: 4;
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-5 {
      display: block;
      left: -176px;
      top: 174px;
    }
  }
  .main-header--home__layout .circle-6 {
    animation: MoveUpDown 8s ease-in-out infinite;
    animation-delay: -2.5s;
    left: -5%;
    top: -62%;
    width: 500px;
    z-index: 1;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-6 {
      left: -70px;
      top: -75%;
      width: auto;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-6 {
      left: -150px;
      top: -420px;
    }
  }
  .main-header--home__layout .circle-7 {
    animation: MoveUpDown 7s ease-in-out infinite;
    animation-delay: -5s;
    left: 7%;
    top: 39%;
    width: 70px;
    z-index: 2;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-7 {
      left: 100px;
      top: 34%;
      width: 110px;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-7 {
      left: 200px;
      top: 75px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-8 {
    animation: MoveUpDown 6s ease-in-out infinite;
    animation-delay: -8s;
    left: 30%;
    top: 77%;
    width: 55px;
    z-index: 2;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-8 {
      left: 230px;
      width: 90px;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-8 {
      left: 373px;
      top: 430px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-9 {
    animation: MoveUpDown 5s ease-in-out infinite;
    animation-delay: -0.5s;
    left: 40%;
    top: 87%;
    width: 20px;
    z-index: 3;
  }
  @media screen and (min-width: 40em) {
    .main-header--home__layout .circle-9 {
      left: 290px;
      width: 40px;
    }
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-9 {
      left: 452px;
      top: 496px;
      width: auto;
    }
  }
  .main-header--home__layout .circle-10 {
    animation: MoveUpDown 5s ease-in-out infinite;
    animation-delay: -9s;
    display: none;
    left: -48%;
    top: 92%;
    z-index: 3;
  }
  @media screen and (min-width: 64em) {
    .main-header--home__layout .circle-10 {
      display: block;
      left: 481px;
      top: 336px;
    }
  }
  .transition--header__fade-in {
    opacity: 0;
  }
  .transition--header.transition-end .transition--header__fade-in {
    opacity: 1;
  }
  @media screen and (min-width: 64em) {
    .transition--header.transition-end .device-tablet {
      /* left: -497px; */
      /* top: 100px; */
      top: 80px;
      width: auto;
      max-width: 500px;
      left: -50px;
    }
    .transition--header.transition-end .device-laptop {
      /* left: -497px; */
      /* top: 100px; */
      /* max-width: 464px; */
      left: -425px;
      top: 85px;
      width: auto;
      max-width: 380px;
      z-index: 10;
    }
  }
  .opacity-2 {
    opacity: 0.2 !important;
  }
  .opacity-5 {
    opacity: 0.5 !important;
  }
  .opacity-8 {
    opacity: 0.8 !important;
  }
  .opacity-9 {
    opacity: 0.9 !important;
  }

  .youtube-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  }

  .responsive-iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .get-started-header {
    height: 175px;
    position: relative;
  }

  .get-started-img {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    height: 125px;
    transform: translate(-50%, -50%);
    -webkit-filter: drop-shadow(5px 5px 5px #222);
    filter: drop-shadow(5px 5px 5px #222);
  }

  .fade-active {
    transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1),
      transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .fade-visible {
    opacity: 1;
    transform: translateX(0);
  }
  .fade-active:not(.fade-visible) {
    opacity: 0;

    transform: translateX(15px);
  }

  .shadow-card {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
  .instruction-video-bottom {
    padding-bottom: 192px !important;
  }
  @media screen and (max-width: 960px) {
    .instruction-video-bottom {
      padding-bottom: 150px !important;
    }
  }

  .gradient-text-aqua-purple {
    background: linear-gradient(130deg, #3bf0e4 -6.8%, #bca1f7 70%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .gradient-text-purple-red {
    background: linear-gradient(87.54deg, #9867f0 -6.8%, #ed4e50 84.14%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .gradient-text-orange-yellow {
    background: linear-gradient(267.91deg, #ffe57f 9.35%, #ff7170 96.48%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .gradient-text-blue {
    background: linear-gradient(
      90deg,
      rgba(2, 0, 36, 1) 0%,
      rgba(51, 139, 236, 1) 35%,
      rgba(0, 212, 255, 1) 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .gradient-text-blue-purple {
    background: linear-gradient(90.91deg, #027bfd -24.67%, #9f51fb 53.55%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .gradient-text-green-blue {
    background: linear-gradient(90deg, #05aa82, #1c8df0);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
</style>
